import { render, staticRenderFns } from "./FormPreAtende.vue?vue&type=template&id=f4a0fe16&"
import script from "./FormPreAtende.vue?vue&type=script&lang=js&"
export * from "./FormPreAtende.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports